import React, { useState, useCallback } from 'react';
import { UP, DOWN, TAB } from 'Shared/keyboard';
const SelectionContext = React.createContext(null);
export const ProductCardSelectionProvider = ({ children, selectableIndexes, keepIndexOnBlur }) => {
    const [index, setIndex] = useState(-1);
    const moveDown = useCallback(() => {
        const next = index === selectableIndexes.length - 1 ? 0 : index + 1;
        setIndex(next);
    }, [selectableIndexes, index]);
    const moveUp = useCallback(() => {
        const next = index === 0 ? selectableIndexes.length - 1 : index - 1;
        setIndex(next);
    }, [selectableIndexes, index]);
    const onKeyDown = useCallback((e) => {
        if (selectableIndexes.length <= 1 || index === -1) {
            return;
        }
        if (e.keyCode === DOWN) {
            e.preventDefault();
            moveDown();
        }
        if (e.keyCode === UP) {
            e.preventDefault();
            moveUp();
        }
        if (e.keyCode === TAB) {
            e.preventDefault();
            moveDown();
        }
        if (e.shiftKey && e.keyCode === TAB) {
            e.preventDefault();
            moveUp();
        }
    }, [selectableIndexes, index]);
    const setIndexIfAllowed = useCallback((index) => {
        const indexPosition = selectableIndexes.indexOf(index);
        if (indexPosition > -1) {
            setIndex(indexPosition);
        }
    }, [selectableIndexes]);
    const resetSelectedIndex = useCallback(() => {
        setIndex(-1);
    }, [setIndex]);
    const onBlur = useCallback(() => {
        if (!keepIndexOnBlur) {
            resetSelectedIndex();
        }
    }, [setIndex, keepIndexOnBlur]);
    return (React.createElement(SelectionContext.Provider, { value: {
            selectedIndex: selectableIndexes[index],
            setSelectedIndex: setIndexIfAllowed,
            resetSelectedIndex,
        } },
        React.createElement("div", { tabIndex: 0, onKeyDown: onKeyDown, onBlur: onBlur }, children)));
};
export const ProductCardSelection = SelectionContext.Consumer;
